var Smaakwiel = function($container, options) {
    this.settings = $.extend({
        type: '',
        smaken: {},
        datasetSwitches: '.dataset a',
        formSelector: 'form[name=eigen-smaakwiel]',
        colors: ['#e1ab53', '#5e8818', '#ff696b', '#454d53'],
        eigenSmaakwielen: {}
    }, options);

    this.usedColorIDs = [];
    this.eigenDataSliders = {};
    this.activeDatasets = {};
    this.labels = [];
    this.userKey = null;

    for (var smaak_key in this.settings.smaken) {
        var label = this.settings.smaken[smaak_key];

        if (label == 'Gedroogd Fruit') {
            label = ['Gedroogd', 'Fruit'];
        }

        this.labels.push(label);
    }

    this.canvas = $container.append('<canvas>').find('canvas').get(0);
    this.ctx    = this.canvas.getContext('2d');
    this.chart  = new Chart(this.ctx, {
        type: 'radar',
        options: {
            responsive: true,
            devicePixelRatio: 3,
            legend: {
                display: false
            },
            scale: {
                gridLines: {
                    display: false
                },
                pointLabels: {
                    fontFamily: 'Oswald',
                    fontStyle: 'normal',
                    fontColor: '#474747',
                    fontSize: $(window).width() < 400 ? 16 : 16
                },
                ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 5,
                    stepSize: 1
                },
                angleLines: {
                    lineWidth: 1,
                    color: '#888'
                }
            },
            tooltips: {
                cornerRadius: 0,
                xPadding: 10,
                yPadding: 10,
                bodyFontFamily: 'Oswald',
                bodyFontSize: 12,
                headerFontFamily: 'Oswald',
                headerFontSize: 12
            }
        },
        data: {
            labels: this.labels
        }
    });

    this.initSwitches();
    this.initEigenDataSliders();
    this.loadEigenData();
    this.initSliderEvents();
};

Smaakwiel.prototype.setType = function(type) {
    this.settings.type = type;
    this.loadEigenData();
    this.initEigenDataSliders();
    this.initSliderEvents();
};

Smaakwiel.prototype.update = function(datasets) {
    var self        = this;
    var newDatasets = $.extend({}, datasets);

    for (var i in newDatasets) {
        newDatasets[i] = $.extend(newDatasets[i], {
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            backgroundColor: "transparent",
            borderWidth: $(window).width() < 400 ? 1.5 : 3
        });
    }

    newDatasets = $.map(newDatasets, function(value, index) {
        return [value];
    });

    for (var i in newDatasets) {
        if (newDatasets[i].data.constructor !== Array) {
            var datasetData = [];

            for (var smaak_key in self.settings.smaken) {
                datasetData.push(newDatasets[i].data[smaak_key] || 0);
            }

            newDatasets[i].data = datasetData;
        }
    }

    this.chartDatasets = newDatasets;
    this.updateColors();

    setTimeout(function() {
        self.chart.data.datasets = newDatasets;
        self.chart.update();
    }, 500);
};

Smaakwiel.prototype.updateColors = function() {
    for (var i in this.chartDatasets) {
        var kennerID    = this.chartDatasets[i].id;
        var colorSet    = false;
        var kennerColor = '';

        for (var j in this.usedColorIDs) {
            if (this.usedColorIDs[j] == kennerID) {
                kennerColor = this.settings.colors[j];
                colorSet = true;
            }
        }

        if (!colorSet) {
            for (var j in this.settings.colors) {
                if (this.usedColorIDs[j] == undefined) {
                    this.usedColorIDs[j] = kennerID;
                    kennerColor = this.settings.colors[j];
                    break;
                }
            }
        }

        this.chartDatasets[i].borderColor = kennerColor;
        $('.datasets [data-kenner-id=' + kennerID + '] .icon').css('border-color', kennerColor).find('.check').css('background-color', kennerColor);
    }

    // Unset unused colors
    for (var i in this.usedColorIDs) {
        var colorUsed = false;

        for (var j in this.chartDatasets) {
            if (this.chartDatasets[j].id == this.usedColorIDs[i]) {
                colorUsed = true;
            }
        }

        if (!colorUsed) {
            delete this.usedColorIDs[i];
        }
    }
};

Smaakwiel.prototype.getColor = function(kennerID) {
    for (var i in this.usedColorIDs) {
        if (this.usedColorIDs[i] == kennerID) {
            return this.settings.colors[i];
        }
    }

    return 'black';
};

Smaakwiel.prototype.setEigenData = function(data) {
    var eigenSmaakwielData = $('.datasets a[data-kenner-id=1]').data('smaakwiel');

    if (eigenSmaakwielData !== undefined) {
        eigenSmaakwielData.data = data;
    }
};

Smaakwiel.prototype.loadEigenData = function() {
    var self      = this;
    var eigenData = this.settings.eigenSmaakwielen[this.settings.type] || false;

    if (eigenData) {
        var parsedData = typeof(eigenData) == 'string' ? JSON.parse(eigenData) : eigenData;

        for (var smaak_key in parsedData) {
            if (this.eigenDataSliders[smaak_key] != undefined) {
                this.eigenDataSliders[smaak_key].slider('setValue', parsedData[smaak_key], false, true);
            }
        }

        self.setEigenData(parsedData);
        $('.datasets a[data-kenner-id=1]').trigger('append');

        $(self.settings.formSelector).find('[name=remarks]').val(eigenData.remarks);
    }
};

Smaakwiel.prototype.initSliderEvents = function() {
    var self = this;

    for (var smaak_key in this.eigenDataSliders) {
        this.eigenDataSliders[smaak_key].on('change', function() {
            var data  = {};

            $('.smaakwiel-slider').each(function() {
                var smaak = $(this).data('smaak');
                data[smaak] = $(this).val();
            });

            self.setEigenData(data);
            $('.datasets a[data-kenner-id=1]').trigger('append');
        });
    }
};

Smaakwiel.prototype.initEigenDataSliders = function() {
    var self = this;

    for (var smaak_key in this.settings.smaken) {
        var $smaak_slider = $('#smaakwiel-' + smaak_key + ' .smaakwiel-slider');

        if ($smaak_slider.length === 0) {
            return;
        }

        this.eigenDataSliders[smaak_key] = $smaak_slider.slider({
            labelledby: 'smaakwiel-' + smaak_key + '-label'

        }).on('change', function() {
            var value = $(this).val();
            var smaak = $(this).data('smaak');
            var left  = $('#smaakwiel-' + smaak + ' .slider-handle').not('.hide').css('left');

            $('#smaakwiel-' + smaak + '-label').text(value).css('left', left);
        }).trigger('change');

        if (this.settings.type === '') {
            this.eigenDataSliders[smaak_key].slider('disable');
        } else {
            this.eigenDataSliders[smaak_key].slider('enable');
        }
    }
};

Smaakwiel.prototype.initSwitches = function() {
    var self = this;

    if ($('.datasets a[data-kenner-id=1]').length == 0) {
        $eigenSwitch = $('<a href="#" data-kenner-id="1" data-smaakwiel="{}"></a>');
        $datasets    = $('<div class="datasets"/>').append($eigenSwitch);
        $datasets.appendTo('body');
    }

    $(this.settings.datasetSwitches).on('click append', function(e) {
        e.preventDefault();

        var $item         = $(this).find('.item').clone();
        var kennerID      = $(this).data('kenner-id');
        var smaakwielData = $(this).data('smaakwiel');

        if (self.activeDatasets[kennerID] != undefined && e.type != 'append') {
            delete self.activeDatasets[kennerID];
            $('.datasets-selected li[data-kenner-id=' + kennerID + ']').remove();
            $(this).removeClass('active');

        } else {
            if (Object.keys(self.activeDatasets).length >= 4 && self.activeDatasets[kennerID] == undefined) {
                if (kennerID != 1) {
                    $('.max-warning').fadeIn();
                }

                return false;
            }

            self.activeDatasets[kennerID] = smaakwielData;

            if ($('li[data-kenner-id="' + kennerID + '"]').length == 0) {
                $('<li data-kenner-id="' + kennerID + '">').append($item).appendTo('.datasets-selected');
            }

            $(this).addClass('active');
        }

        self.update(self.activeDatasets);
    });
};

Smaakwiel.prototype.getFormData = function() {
    var data = {};

    $.each($(this.settings.formSelector).serializeArray(), function() {
       data[this.name] = this.value;
    });

    return data;
};

Smaakwiel.prototype.getVoteData = function() {
    var data = $.extend(this.getFormData(), {
        user_secret_key: this.userKey,
        type: this.settings.type,
        smaken: {},
    });

    for (var smaak_key in this.eigenDataSliders) {
        data.smaken[smaak_key] = this.eigenDataSliders[smaak_key].val();
    }

    return data;
};

Smaakwiel.prototype.setUserKey = function(key) {
    this.userKey = key;
};

Smaakwiel.prototype.setShareKey = function(key) {
    if (this.settings.eigenSmaakwielen[this.settings.type] == undefined) {
        this.settings.eigenSmaakwielen[this.settings.type] = {};
    }

    this.settings.eigenSmaakwielen[this.settings.type].share_key = key;
};

Smaakwiel.prototype.getShareKey = function() {
    return this.settings.eigenSmaakwielen[this.settings.type].share_key;
};
